// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * Whether the controller reported back the value it was told to set.
 *
 * Tri-state rather than bool because "not checked" and "checked and wrong" are
 * different facts and a bool would collapse them. A `ByOrder` correlation
 * carries no value to compare, so `Unknown` is its honest answer.
 */
export enum AckVerified {
  /**
   * Nothing to check, or not an acknowledgement.
   */
  Unknown = 0,

  /**
   * The reported value agrees with what was commanded.
   */
  Yes = 1,

  /**
   * The controller acknowledged, and did NOT do what it was told. The
   * interesting case, and the reason this is not folded into AckOutcome.
   */
  No = 2,
}
